<template>
	<div>
		<div class="row">
			<div class="col-md-12">
				<h2 class="text-primary"><i class="fas fa-coins" /> Contas e Caixas</h2>
			</div>
		</div>

		<div class="row mt-2">
			<div class="col-md-4">
				<account-select-input
					:value="selectedAccount"
					@input="updateSelectedAccount($event)"
				/>
			</div>
			<div class="col-md-8 d-flex justify-content-end">
				<div class="form-group">
					<button
						v-if="this.$acl.can('accountTransactionCreateEdit')"
						class="btn btn-sm btn-primary mr-2"
						@click="$router.push('/fluxodecaixa')"
					>
						<i class="fas fa-chart-line" />
						Fluxo de caixa
					</button>
					<button
						class="btn btn-sm btn-primary mr-2"
						@click="$router.push('/caixas/gerenciar')"
					>
						<i class="fas fa-cog" />
						Gerenciar Contas / Caixas
					</button>
				</div>
			</div>
		</div>

		<hr />
		<br />
		<component ref="indexComponent" :is="indexType" />
	</div>
</template>

<script>
	import AccountSelectInput from "@/components/account/inputs/AccountSelectInput";
	import AccountIndex from "@/components/account/sections/AccountIndex";
	import DrawerIndex from "@/components/account/sections/DrawerIndex";

	export default {
		components: {
			AccountSelectInput,
			AccountIndex,
			DrawerIndex,
		},

		data: function () {
			return {
				//selectedAccount: null,
			};
		},

		async mounted() {
			if (!this.selectedAccount) {
				await this.$store.dispatch("account/getAccounts", { status: 1 }).then((response) => {
					this.$store.commit('account/setSelectedAccount', this.accounts[0].id)
				});
			}

			this.$store.commit("pageHasLoaded");
		},

		computed: {
			accounts() {
				return this.$store.getters['account/allowedAccounts']
			},

			selectedAccount() {
				return this.$store.getters['account/selectedAccount']
			},

			indexType() {
				if (this.selectedAccount) {
					return (this.selectedAccount.type !== 'd') ? 'accountIndex' : 'drawerIndex'
				}
			}
		},

		watch: {
			selectedAccount() {
				//this.$store.commit('account/setSelectedAccount', this.selectedAccount.id)

				// this.$nextTick(() => {
				//   this.$refs.indexComponent.setAccount(this.selectedAccount)
				// })

				// if (typeof this.$refs.indexComponent != 'undefined') {
				//   console.log('setting...', this.selectedAccount)
				//   this.$refs.indexComponent.setAccount(this.selectedAccount)
				// }
			}
		},

		methods: {
			updateSelectedAccount(account) {
				console.log('update')
				this.$store.commit('account/setSelectedAccount', account.id)
			}
		}
	};
</script>
